import React from "react";
import "./DashBoard.less";
// import {  getFormattedString } from "../../utils/generic";
export default function RenderKeyValueForm({ data }) {
  return (
    <>
      {(data || []).map((item, index) => (
        <div
          className="row col-xs-12 keyvalue-container dash-widg-keyvalue-row"
          key={"keyvalueDashValue" + index}
        >
          <div className="col-xs-8 kv-title">
            {/* {getPropertyNoCase(item, "attributeName")} */}
          </div>
          <div className="col-xs-4 kv-value">
            <div
              className={
                item.showColor == "True"
                  ? parseFloat(item.attributeValue) <= 30 &&
                    parseFloat(item.attributeValue) >= 0
                    ? "kv-value-div error-gsf-class"
                    : parseFloat(item.attributeValue) <= 60 &&
                      parseFloat(item.attributeValue) > 30
                    ? "kv-value-div warning-gsf-class "
                    : parseFloat(item.attributeValue) > 60
                    ? "kv-value-div green-gsf-class "
                    : "kv-value-div"
                  : "kv-value-div"
              }
            >
              {item.attributeValue == 0 &&
              item.sectionName == "Guard Force Patrols"
                ? "0%"
                // : getFormattedString(
                //     getPropertyNoCase(item, "attributeValue"),
                //     getPropertyNoCase(item, "DataFormat"),
                //     "-"
                //   )
                : ""
              }
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
